import React from 'react';
import './Support.css';
import supportImage from '../../assets/support.png';

function Support() {
  return (
    <section className="support">
      <h2 style={{ color: 'black' }}>Support Us</h2>
      <img src={supportImage} alt="Support illustration" className="support-image" />
      <p>If we helped you save on your monthly lease payments, please contribute the amount you feel appropriate. Your support will allow us to continue our service and our mission to help others LeasEiZi!</p>
      <div className="support-buttons">
        <a href="https://www.buymeacoffee.com/LeasEizi" className="support-btn">Buy Us A Pizza 🍕</a>
        <a href="https://pay.leaseizi.com/" className="support-btn">Support LeasEiZi</a>
      </div>
    </section>
  );
}

export default Support;
